export default "__VITE_ASSET__BGtYkpbk__"